/*
 * @Author: Marte
 * @Date:   2017-11-7 
 * @Last Modified by:   liujinming
 * @Last Modified time: 2017-11-7
 */

'use strict';
/**
 *  Module
 *
 * Description
 */
angular.module('repSummServiceModule', ['createNewReportModule', 'reportSummaryNewsModule','broadcastStatusModule'])
    .factory('repSummService', ["$modal", "$q", function($modal, $q) {
    	return{
            /**
             * [createNewReport description] 新建或编辑报题
             * @param  {[type]} groupId  [description] 分组id
             * @param  {[type]} reportId [description] 报题id
             * @return {[type]}          [description]
             */
    		createNewReport: function(groupId, reportId,channelsData){
    			var defer = $q.defer();
                var modalInstance = $modal.open({
                    templateUrl: "./planningCenter/command/reportSummary/repSummService/createNewReport/createNewReport_tpl.html",
                    windowClass: 'createNewReport_window',
                    backdrop: false,
                    controller: "createNewReportCtrl",
                    resolve: {
                        item: function() {
                            return {
                                groupId: groupId,
                                reportId: reportId,
                                channelsData:channelsData,
                            };
                        }
                    }
                });
                //关闭弹窗
                modalInstance.result.then(function(result) {
                    defer.resolve(result);
                }, function() {
                    defer.reject("cancle");
                });
                return defer.promise;
    		},
        /**
         * [createNewReport description] 新建或编辑制播状态
         * @param  {[type]} groupId  [description]
         * @param  {[type]} reportId [description]
         * @return {[type]}          [description]
         */
         createBroadcastStatus: function(reportId,records,metaTypeInfo){
            var defer = $q.defer();
            var modalInstance = $modal.open({
                templateUrl: "./planningCenter/command/reportSummary/repSummService/broadcastStatus/broadcastStatus_tpl.html",
                windowClass: 'broadcastStatus_window',
                backdrop: false,
                controller: "broadcastStatusCtrl",
                resolve: {
                    item: function() {
                        return {
                            ReportId: reportId,
                            records:records,
                            metaTypeInfo:metaTypeInfo
                        };
                    }
                }
            });
            //关闭弹窗
            modalInstance.result.then(function(result) {
                defer.resolve(result);
            }, function() {
                defer.reject("cancle");
            });
            return defer.promise;
        }
    	};
    }]);